module.exports = __webpack_public_path__ + "0bf3b36fbe2e995787c21324e030370c.png";


//////////////////
// WEBPACK FOOTER
// ./components/layout/Header/header.png
// module id = LwpJ
// module chunks = 0